module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.client) ? _c('nav', {
    staticClass: "nav"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n        " + _vm._s(_vm.paginationlabel ? _vm.paginationlabel : 'Eintrag') + "\n        "), (_vm.pagination.from > 0) ? _c('span', [_vm._v(_vm._s(_vm.pagination.from))]) : _c('span', [_vm._v("0")]), _vm._v(" - " + _vm._s(_vm.pagination.to) + " von " + _vm._s(_vm.pagination.total) + "\n\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "col-md-6 pull-right"
  }, [_c('div', {
    staticClass: "btn-group pull-right btn-default"
  }, [(_vm.pagination.prevPage) ? _c('a', {
    staticClass: "btn btn-default btn-sm",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('prev');
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  })]) : _c('a', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "disabled": true
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  })]), _vm._v(" "), (_vm.pagination.nextPage) ? _c('a', {
    staticClass: "btn btn-default btn-sm",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('next');
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-right"
  })]) : _c('a', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "disabled": true
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-right"
  })])])])])]) : _c('nav', {
    staticClass: "nav"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n        " + _vm._s(_vm.paginationlabel ? _vm.paginationlabel : 'Eintrag') + "\n        "), (_vm.pagination.from > 0) ? _c('span', [_vm._v(_vm._s(_vm.pagination.from))]) : _c('span', [_vm._v("0")]), _vm._v(" - " + _vm._s(_vm.pagination.to) + " von " + _vm._s(_vm.filtered.length) + "\n        "), (_vm.filtered.length < _vm.pagination.total) ? _c('span', [_vm._v("(gefiltert aus " + _vm._s(_vm.pagination.total) + " Einträgen insgesamt)")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 pull-right"
  }, [_c('div', {
    staticClass: "btn-group pull-right"
  }, [(_vm.pagination.prevPage) ? _c('a', {
    staticClass: "btn btn-default btn-sm",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('prev');
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  })]) : _c('a', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "disabled": true
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  })]), _vm._v(" "), (_vm.pagination.nextPage) ? _c('a', {
    staticClass: "btn btn-default btn-sm",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('next');
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-right"
  })]) : _c('a', {
    staticClass: "btn btn-default btn-sm",
    attrs: {
      "disabled": true
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-right"
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-046ddac9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Pagination.vue
// module id = 102
// module chunks = 0